type Sizes = {
  width: number;
  height: number;
};

const getGCD = (a: number, b: number): number => {
  if (!b) return a;

  return getGCD(b, a % b);
};

const getAspectRatio = ({ width, height }: Sizes) => {
  const gcd = getGCD(width, height);
  return [width / gcd, height / gcd];
};

export default getAspectRatio;
